import CT from '@marketplace-ai/tags';
import { useSelector } from '@xstate/react';
import { EmptyState, FormDialog, TableCard } from '~/components';
import { BasicGrid } from '~/components/agGrid/Grid';
import { PROVIDER_PAGE_KEYS } from '~/routing/routes';
import { useCMETrainingRef } from '../account/vaultSelectors';
import { CMETrainingForm } from './CMETrainingForm';
import { createCMETrainingCols } from './constants';

const TAGS = CT.cmeTraining.table;

const CMENoRowsOverlay = () => (
  <EmptyState
    pageKey={PROVIDER_PAGE_KEYS.cmeTraining}
    title="No CME records yet"
    cyTag={TAGS.emptyState}
  />
);

export const CMETrainingDetails = () => {
  const { cmeTrainingRef, openModal, closeModal, deleteCME, openEditModal } = useCMETrainingRef();
  if (!cmeTrainingRef) {
    return null;
  }
  const { data, loading, form, modal } = useSelector(cmeTrainingRef, (state) => state.context);
  const { create, edit } = useSelector(cmeTrainingRef, (state) => state.context.modal);

  const handleEdit = (id: number) => {
    openEditModal(id);
  };

  const handleDelete = (id: number) => {
    deleteCME(id);
  };

  return (
    <>
      <TableCard
        mobilePageHeader
        title="Continuing Medical Education (CME)"
        addLabel="Add New Training"
        onAddClick={openModal}
        addBtnTag={TAGS.addBtn}
        layoutTag={CT.cmeTraining.layout}
      >
        <BasicGrid
          newRecordsTable="cme_trainings"
          data={data}
          loading={loading}
          colDefs={createCMETrainingCols({ handleEdit, handleDelete })}
          pagination={true}
          cyTag={TAGS.grid}
          noRowsOverlayComponent={CMENoRowsOverlay}
        />
      </TableCard>

      <FormDialog
        editing={edit}
        creating={create}
        onClose={closeModal}
        title={edit ? 'Edit training' : 'Create a new training '}
      >
        <CMETrainingForm form={form} create={modal.create} />
      </FormDialog>
    </>
  );
};
